import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import * as Sentry from "@sentry/react";
import { Config } from "./utils/config";
import ErrorBoundary from "./ErrorBoundary";
import PlaceOrder from "./screens/place-order/PlaceOrder";
import NewPlaceOrder from "./screens/place-order/NewPlaceOrder";
Sentry.init({
  dsn: Config.env.app.sentry.dsn,
  integrations: [],
});

const cartId = localStorage.getItem("cartId");

// Function to get query parameters from the URL
// function getQueryParams() {
//   const params = new URLSearchParams(window.location.search);

//   return {
//     token: params.get("token"),
//     id: params.get("id"),
//     type: params.get("type"),
//   };
// }

// let token: string | null;
// let id: string | null;
// let type: string | null | any;

// if (window.REACT_APP_TOKEN && window.REACT_APP_ID) {
//   token = window.REACT_APP_TOKEN;
//   id = window.REACT_APP_ID;
//   type = window.REACT_APP_TYPE;
// } else {
//   const queryParams = getQueryParams();
//   token = queryParams.token;
//   id = queryParams.id;
//   type = queryParams.type;
// }

const MainApp = () => {
  // Function to get query parameters from the URL
  function getQueryParams() {
    const params = new URLSearchParams(location.search);

    return {
      token: params.get("token"),
      id: params.get("id"),
      type: params.get("type"),
      return_token: params.get("return_token"),
    };
  }

  let token: string | null;
  let id: string | null;
  let type: string | null | any;

  if (window.REACT_APP_TOKEN && window.REACT_APP_ID) {
    token = window.REACT_APP_TOKEN;
    id = window.REACT_APP_ID;
    type = window.REACT_APP_TYPE;
  } else {
    const queryParams = getQueryParams();
    token = queryParams.token;
    id = queryParams.id;
    type = queryParams.type;
  }

  return <App token={token} id={id} type={type} />;
};

ReactDOM.createRoot(document.getElementById("root")!).render(
  <I18nextProvider i18n={i18n}>
    <React.StrictMode>
      <ErrorBoundary>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<MainApp />} />
            <Route path="/order-placed" element={<NewPlaceOrder />} />
          </Routes>
        </BrowserRouter>
      </ErrorBoundary>
    </React.StrictMode>
  </I18nextProvider>
);
